import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarTile } from "@perxis-auto/ui-kit/lib/components/CarTile";
const TileMarkers = memo(function TileMarkers2({
  items,
  isLoading = false,
  limit = 3,
  mode = "singleLineDynamic",
  ...props
}) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(CarTile.MarkersSkeleton, {});
  }
  if (!items.length) {
    return null;
  }
  return /* @__PURE__ */ jsx(CarTile.Markers, { items, limit, mode, ...props });
});
export {
  TileMarkers
};
